export default function RecoveryTiers() {
  return (
    <div className="p-6 max-w-6xl mx-auto">
      <div className="mb-4 rounded border border-yellow-700 bg-yellow-900/20 text-yellow-300 px-4 py-3 text-sm">
        HIPAA Notice: Recovery services include audit logging and access controls suitable for regulated healthcare environments.{' '}
        <a href="/compliance" className="underline text-yellow-200">Compliance Details</a>
      </div>

      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-semibold">BoltOS Recovery Vault (HIPAA‑Compliant)</h1>
        <a href="/billing/upgrade" className="px-3 py-1.5 text-sm rounded bg-neutral-800 hover:bg-neutral-700 border border-neutral-700">← Back to Billing</a>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <TierCard title="Included Recovery" price="Included" badge="INCLUDED" disabled ctaLabel="Included" bullets={[
          '12‑day retention',
          'Storage 10 GB included',
          'Self‑service recovery',
          'Basic audit entry',
          'Best‑effort support'
        ]} />

        <TierCard title="Essential Recovery" price="$99/mo" bullets={[
          '30‑day retention',
          'Storage 100 GB included',
          'Overage $0.15/GB',
          'Self‑service recovery',
          'Basic audit trail',
          'Email notifications',
          'Business‑hours support'
        ]} />

        <TierCard title="Professional Recovery" price="$249/mo" recommended bullets={[
          '60‑day retention',
          'Storage 500 GB included',
          'Overage $0.10/GB',
          'Dual‑approval purge protection',
          'Advanced audit logs (IP, agent)',
          'SMS + Email alerts',
          'Priority support (4h)',
          'Bulk recovery tools'
        ]} />

        <TierCard title="Enterprise Compliance" price="$499/mo" bullets={[
          '90‑day+ retention',
          'Storage Unlimited · Overage Custom',
          'Immutable audit trail',
          'Legal hold capability',
          'Dedicated account manager',
          'Cross‑region replication',
          '99.99% recovery SLA'
        ]} />
      </div>

      <div className="mt-4 text-sm text-neutral-400">
        Note: 12‑day recycle bin is included for all organizations. Selecting a paid Recovery Vault tier automatically enables extended retention and advanced controls (e.g., immutable audit, purge protections, priority support) for your organization.{' '}
        <a href="/billing/retention-controls" className="underline text-neutral-300 hover:text-white">Learn more about Retention & Controls</a>.
      </div>
    </div>
  );
}

function TierCard({ title, price, bullets, recommended, badge, disabled, ctaLabel }: { title: string; price: string; bullets: string[]; recommended?: boolean; badge?: string; disabled?: boolean; ctaLabel?: string }) {
  return (
    <div className={`h-full flex flex-col rounded-lg border ${recommended ? 'border-blue-500' : 'border-neutral-800'} bg-neutral-900 p-5`}> 
      <div className="flex items-center justify-between mb-2">
        <div className="text-lg font-semibold text-neutral-100">{title}</div>
        <div className="flex items-center gap-2">
          {badge && <span className="text-xs px-2 py-1 rounded bg-emerald-700 text-white">{badge}</span>}
          {recommended && <span className="text-xs px-2 py-1 rounded bg-blue-600 text-white">RECOMMENDED</span>}
        </div>
      </div>
      <div className="text-2xl font-semibold mb-3">{price}</div>
      <ul className="text-sm text-neutral-300 space-y-1 mb-4">
        {bullets.map((b, i) => <li key={i}>• {b}</li>)}
      </ul>
      <button className={`mt-auto w-full px-4 py-2 rounded ${disabled ? 'bg-neutral-700 text-neutral-300 cursor-not-allowed opacity-60' : 'bg-blue-600 hover:bg-blue-500 text-white'}`} disabled={!!disabled}>
        {ctaLabel || `Select ${title.replace(/ .*/, '')}`}
      </button>
    </div>
  );
}


